import { render, staticRenderFns } from "./ActivityVerticalTextButtonsWithAudio.vue?vue&type=template&id=ae7ac896&scoped=true"
import script from "./ActivityVerticalTextButtonsWithAudio.vue?vue&type=script&lang=ts"
export * from "./ActivityVerticalTextButtonsWithAudio.vue?vue&type=script&lang=ts"
import style0 from "./ActivityVerticalTextButtonsWithAudio.vue?vue&type=style&index=0&id=ae7ac896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7ac896",
  null
  
)

export default component.exports